module.exports = __webpack_public_path__ + "static/media/buick.9a5d98bf.jpg";